import React from 'react';
import moduleJeuneImg from '../assets/images/module_jeune_hmf.png';
import { useStrapi } from '../services/useStrapi';
import { getModuleJeune } from '../services/api';

const FALLBACK = {
  titre: 'MODULE JEUNE',
  description: `Destiné aux particuliers, aux établissements scolaires (enseignants, CPE, AED/AESH, vie scolaire),
ainsi qu'aux associations jeunesse, missions locales et collectivités, ce module s'adresse à tous les
professionnels en contact avec les jeunes. Il permet de mieux comprendre le développement de
l'adolescent et d'intervenir efficacement face aux troubles et situations de mal-être spécifiques à cet\u00a0âge.`,
  objectifs: [
    { texte: 'Comprendre le développement de l\'adolescent et l\'impact des troubles psychiques sur cette période sensible.' },
    { texte: 'Repérer les signes et les symptômes de la dépression, de l\'anxiété, des crises suicidaires, d\'automutilation, des troubles des conduites alimentaires et des gestes/comportements non suicidaires.' },
    { texte: 'Intervenir avec calme et discernement, en appliquant le plan d\'action AERER.' },
    { texte: 'Adopter une posture d\'écoute active, bienveillante et sécurisante, même face aux situations difficiles.' },
    { texte: 'Orienter efficacement les jeunes vers les ressources adaptées.' },
  ],
  sessions: [
    {
      titre: '1. Adolescence & introduction PSSM',
      description: 'Comprendre le développement de l\'adolescent et l\'impact des troubles ; repérer les premiers signes de la dépression et l\'importance de l\'intervention précoce.',
    },
    {
      titre: '2. Dépression, anxiété, crise suicidaire & automutilations',
      description: 'Appliquer le plan d\'action ; évaluer et assister en cas de pensées/comportements suicidaires et des automutilations non suicidaires ; reconnaître les troubles anxieux et leur prévalence.',
    },
    {
      titre: '3. Troubles des conduites alimentaires (TCA)',
      description: 'Signes, risques somatiques, urgence médicale ; traitements efficaces ; application du plan d\'action ; favoriser le repérage précoce.',
    },
    {
      titre: '4. Psychose & usage de substances',
      description: 'Repérer les signes des troubles psychotiques ; facteurs de risque liés aux substances ; premiers secours en cas d\'intoxication/urgence ; application du plan d\'action. Bilan.',
    },
  ],
  url_pdf: 'https://firebasestorage.googleapis.com/v0/b/help-mind-formation.firebasestorage.app/o/jeune_BD.pdf?alt=media&token=dd5fde6f-9b09-4c60-be75-59e00459d342',
  texte_organisation: 'Formats possibles : 2 jours consécutifs, 2 jours non consécutifs (sur 2 semaines), ou 4 demi journées (sur 1 mois max).',
};

const YouthModule = () => {
  const { data, loading } = useStrapi(getModuleJeune);
  const d = data || FALLBACK;

  return (
    <div className="container">
      <section className="section text-center">
        <img src={moduleJeuneImg} alt="Module Jeune" className="module-icon" />
        <h1>{d.titre}</h1>
        <p className="max-w-800">{d.description}</p>
      </section>

      <section className="section text-center">
        <h2>OBJECTIFS</h2>
        <div className="objectives-box">
          {loading ? (
            <p>Chargement…</p>
          ) : (
            <ul className="objectives-list">
              {d.objectifs.map((o, i) => (
                <li key={i}>{o.texte}</li>
              ))}
            </ul>
          )}
        </div>
      </section>

      <section className="section text-center">
        <h2>PROGRAMME</h2>
        <p>Programme en {d.sessions.length} sessions</p>
        <div className="program-box">
          {loading ? (
            <p>Chargement…</p>
          ) : (
            <ul className="program-list">
              {d.sessions.map((s, i) => (
                <li key={i}>
                  <strong>{s.titre}</strong>
                  <br />
                  {s.description}
                </li>
              ))}
            </ul>
          )}
        </div>
        {d.url_pdf && (
          <div style={{ marginTop: '30px' }}>
            <a href={d.url_pdf} target="_blank" rel="noopener noreferrer" className="btn">
              📄 TÉLÉCHARGER LE PROGRAMME COMPLET (PDF)
            </a>
          </div>
        )}
      </section>

      <section className="section text-center">
        <h2>ORGANISATION</h2>
        <div className="organisation-box">
          <svg className="org-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <p>{d.texte_organisation}</p>
        </div>
      </section>
    </div>
  );
};

export default YouthModule;
